module.exports = "/_next/static/images/3040835b734e2df2d6c817eace968932-row-3-transfer.svg.webp";